export function animateHorizontalScroll(
  scrollContainer,
  targetScrollLeft,
  durationMs,
) {
  const {
    scrollLeft: startScrollLeft,
    offsetWidth,
    scrollWidth,
  } = scrollContainer;

  if (targetScrollLeft < 0) {
    targetScrollLeft = 0;
  } else if (targetScrollLeft > scrollWidth - offsetWidth) {
    targetScrollLeft = scrollWidth - offsetWidth;
  }

  const dScroll = targetScrollLeft - startScrollLeft;
  let startTime = performance.now();

  onRequestAnimationFrame();

  function onRequestAnimationFrame() {
    let progress = (performance.now() - startTime) / durationMs;
    if (progress > 1) {
      progress = 1;
    }
    progress = easeOutQuad(progress);

    scrollContainer.scrollLeft = startScrollLeft + dScroll * progress;

    if (progress < 1 && scrollContainer.scrollLeft !== targetScrollLeft) {
      window.requestAnimationFrame(onRequestAnimationFrame);
    }
  }
}

function easeOutQuad(x) {
  return 1 - (1 - x) * (1 - x);
}
